export const DEFAULT_PAGESIZE = 5;

export const DEFAULT_TOOLTIP_TIMEOUT = 3000; // 提示条显示时间
export const DEFAULT_API_TIMEOUT = 10000; // api超时时间

export const DEFAULT_CURRENT_PAGE = 1;

export const IMG = {
  logo: require('./assets/logo.png'),
  tips: require('./assets/tips.jpg'),
};

export type PackageType = {
  id: number;
  artifactUrl: string;
  buildTime: string;
  buildUser: string;
  buildId: string;
  buildTimestamp: string;
  commitidInfo: string;
  packageSize: string;
  versionNumber: string;
  versionType: string;
  updateDescription: string;
  artifactPlist: string | null;
  productSort: string;
  branch: string | null;
};

export type ParamsType = {
  current: number,
  pageSize: number,
  versionType: string,
  productSort?: string,
};

export type QRcodeType = {
  env: 'test' | 'prod';
  version: string | null;
  sort: 'internal' | 'external' | 'beta';
}

type MapType = {
  sort: QRcodeType['sort'];
  /** 模糊匹配：productSort 包含任一关键词即命中 */
  includes: string[];
};

export const SORT_MAPPING: Record<QRcodeType['sort'], MapType> = {
  internal: { sort: 'internal', includes: ['国内'] },
  external: { sort: 'external', includes: ['国外', '海外'] },
  beta: { sort: 'beta', includes: ['beta'] },
};

/** KOL 国内 iOS TestFlight */
export const KOL_CN_TESTFLIGHT_URL = 'https://testflight.apple.com/join/1qaUFgf5';
/** KOL 海外/国外 iOS TestFlight */
export const KOL_OVERSEAS_TESTFLIGHT_URL = 'https://testflight.apple.com/join/AkW1eMtv';

export const IOS_TESTFLIGHT_INSTALL_URL = 'https://apps.apple.com/us/app/testflight/id899247664?mt=8';

export enum USER_AGENT {
  ios = 'ios',
  android = 'android',
}

export const DEFAULT_EMPTY_TEXT = '暂无';

export const AZIR_CONFIG = {
  IOS_TF_URL: 'ios_tf_url',
};
